import {
	IconTool,
    IconChartGridDots,
    IconTournament,
    IconDeviceLaptop,
    IconSettings,
    IconTemplate,
    IconFileDots,
	IconFlag2,
	IconCircleDashedCheck,
    IconArrowLeft
} from '@tabler/icons-react';
import Avatar, { genConfig } from 'react-nice-avatar'
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';
import { lazy } from 'react';
import { InputDataItem } from '@/types';
import Loadable from '@/components/loading/Loadable';
import { AddAgent } from '@/store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@/components/ui/button';
import { useInputData } from '@/store/context/InputDataContext'
import { AppDispatch } from '@/store';
  

const ProfileAgent = Loadable (lazy(() => import('./ProfileAgent')))
const CoreInstruction = Loadable (lazy(() => import('./CoreInstruction')))
const FlowBuilder = Loadable (lazy(() => import('./FlowBuilder')))
const Abilities = Loadable (lazy(() => import('./Abilities')))
const Tools = Loadable (lazy(() => import('./Tools')))
const SubAgents = Loadable (lazy(() => import('./SubAgents')))
const Settings = Loadable (lazy(() => import('./Settings')))
const Configure = Loadable (lazy(() => import('./Configure')))
const SuccessLogic = Loadable (lazy(() => import('./SuccessLogic')))

export default function Addagent() {
	const location = useLocation();
	const agent = location.state?.agent;
    
	useEffect(()=>{
		setInputData(agent?.inputData || [])
	},[agent?.inputData])

	const navigate = useNavigate()
	const dispatch = useDispatch<AppDispatch>();
	const [activeIndex, setActiveIndex] = useState(0);
	const [flowJson, setFlowJson] = useState(agent?.flowJson || {
		nodes: [
			{
				id: '0',
				type: 'input',
				data: {
					label: (
						<>
							<IconFlag2 size={15} color="green" style={{ marginTop: '3px' }} />
							<span style={{ marginLeft: '6px' }}> Starting point </span>
						</>
					),
				},
				position: { x: -100, y: -200 },
				className: 'clickable-node',
			},
		],
	});
	// Define the expected return type of useInputData
	interface InputDataContextType {
		inputData: InputDataItem[];
		setInputData: (data: InputDataItem[]) => void;
	}
	const { loading, agents, error } = useSelector((state:any) => state.addAgent);
	const { inputData, setInputData } = useInputData() as InputDataContextType;
	const [isLoading, setIsLoading] = useState(false)
	const [agentProfile, setAgentProfile] = useState(agent?.agentProfile || []);
	const [coreInstruction, setCoreInsntruction] = useState(agent?.coreInstruction || '');
	const [abilities, setAbilities] = useState(agent?.abilities || []);
	const [subAgents, setSubAgent] = useState(agent?.subAgents || []);
	const [tools, setTools] = useState(agent?.tools || []);
	const [summaryData, setSummaryData] = useState([])
	const [settings, setSettings] = useState(agent?.settings || []);
	const [successLogicValue, setSuccessLogicValue] = useState(agent?.successLogicValue || "");
	const { slug } = useParams();
	const config = genConfig(slug);
	

	const handleItemClick = (index) => {
		setActiveIndex(index);
	};
	
	const handleExport = () => {
		// Create a copy of flowJson with serializable labels
		const serializableFlowJson = {
			...flowJson,
			nodes: flowJson.nodes.map(node => ({
				...node,
				data: {
					...node.data,
					// Replace the React component with a simple string
					label: "Starting point",
				},
			})),
		};
	
		const data = {
			id: (slug === 'new' ? '' : slug),
			user_id: 1,
			raw_data: JSON.stringify({
				flowJson: serializableFlowJson,
				agentProfile: agentProfile,
				coreInstruction: coreInstruction,
				abilities: abilities,
				subAgents: subAgents,
				tools: tools,
				inputData: inputData,
				settings: settings,
				successLogicValue: successLogicValue
			})
        };
		
		dispatch(AddAgent(data));
		if(loading){
			setIsLoading(true)
		}else{
			setTimeout(() => {
				setIsLoading(false);
				navigate('/');
			}, 2000);  
		}
       
	};

	useEffect(() => {

		const serializableFlowJson = {
			...flowJson,
			nodes: flowJson.nodes.map(node => ({
				...node,
				data: {
					...node.data,
					// Replace the React component with a simple string
					label: "Starting point",
				},
			})),
		};
	
		const data = {
			flowJson: serializableFlowJson,
			agentProfile: agentProfile,
			coreInstruction: coreInstruction,
			abilities: abilities,
			subAgents: subAgents,
			tools: tools,
			inputData: inputData,
			settings: settings,
			successLogicValue: successLogicValue
		};


		setSummaryData((previousData) => ({
			...previousData,
			...data,
		}));
	}, [agentProfile, coreInstruction, abilities, subAgents, tools, inputData, flowJson, successLogicValue]);
	

	return (
		<>
			<div className="w-full h-full flex flex-col md:p-2">
                <div className="flex w-full flex-row gap-6 items-center justify-between md:p-4">
                    <div className="flex items-center">
                        <Button
                            variant="ghost"
                            className="mr-4 text-gray-500 hover:text-gray-700"
                            onClick={() => navigate('/')}
                        >
                            <IconArrowLeft size={24} />
                        </Button>
                        <h2 className="text-gray-900 text-2xl mt-2 font-bold">Add Agent</h2>
                    </div>
                    <div className='flex justify-end gap-2'>
                        <Button
                            variant="outline"
							size={'sm'}
                            onClick={() => navigate('/')}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="default"
							size={'sm'}
                            disabled={isLoading}
                            onClick={handleExport}
                        >
                            Save
                        </Button>
                    </div>
                </div>
                <div className="card grid relative flex-grow">
                    <div className="flex h-full">
						<div className="relative bg-zinc-50 w-64 md:p-4 " >
						<ul className="space-y-2 text-slate-400 ">
								<li className="md:py-1">
									<span className="text-slate-600 text-sm mb-3">{agentProfile?.title || "Untitled agent" }</span>
									<button className={`flex items-center py-1.5 px-3 text-gray-900 rounded-lg dark:text-gray w-full mb-1  hover:bg-gray-200 dark:hover:bg-gray-200 font-medium  text-sm
									${activeIndex === 0 ? 'bg-gray-200' : '' }`}
									onClick={() => handleItemClick(0)}
									>
										<div className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-white-900 dark:group-hover:text-white">
											<Avatar style={{ width: '1.5rem', height: '1.4rem' }} {...config} />
										</div>
										<span className=" ms-3 text-gray">Agent Profile</span>
									</button>
								</li>
								<li className="md:py-1">
									<span className="text-slate-600 text-sm mb-3">Agent Instruction</span>
									<button  className={`flex text-sm mb-1   items-center w-full py-1.5 px-3 text-gray-900 rounded-lg dark:text-gray hover:bg-gray-200 dark:hover:bg-gray-200 font-medium 
									${activeIndex === 1 ? 'bg-gray-200' : '' }`}
									onClick={() => handleItemClick(1)}
									>
										<div className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-white-900 dark:group-hover:text-white">
											<IconFileDots size={18}/>
										</div>
										<span className="mb-0.5 ms-1 text-gray">Core Instruction</span>
									</button>
									<button  className={`flex text-sm mb-1   items-center w-full py-1.5 px-3 text-gray-900 rounded-lg dark:text-gray hover:bg-gray-200 dark:hover:bg-gray-200 font-medium 
									${activeIndex === 2 ? 'bg-gray-200' : '' }`}
									onClick={() => handleItemClick(2)}
									>
										<div className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-white-900 dark:group-hover:text-white">
											<IconDeviceLaptop size={18}/>
										</div>
										<span className="mb-0.5 ms-1 text-gray">Flow Builder</span>
									</button>
								</li>
								<li className="md:py-1">
									<span className="text-slate-600 text-sm mb-3">Connected resources</span>
									<button  className={`flex text-sm mb-1   items-center w-full py-1.5 px-3 text-gray-900 rounded-lg dark:text-gray hover:bg-gray-200 dark:hover:bg-gray-200 font-medium 
									${activeIndex === 3 ? 'bg-gray-200' : '' }`}
									onClick={() => handleItemClick(3)}
									>
										<div className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-white-900 dark:group-hover:text-white">
											<IconChartGridDots size={18}/>
										</div>
										<span className="mb-0.5 ms-1 text-gray">Abilities</span>
									</button>
									<button  className={`flex  text-sm mb-1  items-center w-full py-1.5 px-3 text-gray-900 rounded-lg dark:text-gray hover:bg-gray-200 dark:hover:bg-gray-200 font-medium 
									${activeIndex === 4 ? 'bg-gray-200' : '' }`}
									onClick={() => handleItemClick(4)}
									>
										<div className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-white-900 dark:group-hover:text-white">
											<IconTool size={18}/>
										</div>
										<span className="mb-0.5 ms-1 text-gray">Tools</span>
									</button>
									<button  className={`flex text-sm mb-1   items-center w-full py-1.5 px-3 text-gray-900 rounded-lg dark:text-gray hover:bg-gray-200 dark:hover:bg-gray-200 font-medium 
									${activeIndex === 5 ? 'bg-gray-200' : '' }`}
									onClick={() => handleItemClick(5)}
									>
										<div className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-white-900 dark:group-hover:text-white">
											<IconTournament size={18} />
										</div>
										<span className="mb-0.5 ms-1 text-gray">Subagents</span>
									</button>
								</li>
								<li className="md:py-1">
									<span className="text-slate-600 text-sm mb-3">More Option</span>
									<button  className={`flex text-sm mb-1   items-center w-full py-1.5 px-3 text-gray-900 rounded-lg dark:text-gray hover:bg-gray-200 dark:hover:bg-gray-200 font-medium 
									${activeIndex === 6 ? 'bg-gray-200' : '' }`}
									onClick={() => handleItemClick(6)}
									>
										<div className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-white-900 dark:group-hover:text-white">
											<IconSettings size={18}/>
										</div>
										<span className="mb-0.5 ms-1 text-gray">Advanced Settings</span>
									</button>
									<button  className={`flex text-sm mb-1   items-center w-full py-1.5 px-3 text-gray-900 rounded-lg dark:text-gray hover:bg-gray-200 dark:hover:bg-gray-200 font-medium 
									${activeIndex === 7 ? 'bg-gray-200' : '' }`}
									onClick={() => handleItemClick(7)}
									>
										<div className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-white-900 dark:group-hover:text-white">
											<IconTemplate size={18}/>
										</div>
										<span className="mb-0.5 ms-1 text-gray">Configure Template</span>
									</button>

									{/* <button  className={`flex text-sm mb-1   items-center w-full py-1.5 px-3 text-gray-900 rounded-lg dark:text-gray hover:bg-gray-200 dark:hover:bg-gray-200 font-medium 
									${activeIndex === 8 ? 'bg-gray-200' : '' }`}
									onClick={() => handleItemClick(8)}
									>
										<div className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-white-900 dark:group-hover:text-white">
											<IconCircleDashedCheck size={18}/>
										</div>
										<span className="mb-0.5 ms-1 text-gray">Success Logic</span>
									</button> */}
								</li>
								
							</ul> 
						</div>
						<div className="flex-grow border bg-white border-gray-200 rounded-md w-full">
							{(activeIndex === 0) ? 
								<ProfileAgent  config={config} agent={agent} setAgentProfile={setAgentProfile} agentProfile={agentProfile}/> 
								: (activeIndex ===1) ? <CoreInstruction setCoreInsntruction={setCoreInsntruction} coreInstruction={coreInstruction} /> 
								: (activeIndex ===2) ? <FlowBuilder setFlowJson={setFlowJson} flowJson={flowJson}/> 
								: (activeIndex ===3) ? <Abilities setAbilities={setAbilities} abilities={abilities} /> 
								: (activeIndex ===4) ? <Tools tools={tools} setTools={setTools}/> 
								: (activeIndex ===5) ? <SubAgents subAgents={subAgents} setSubAgent={setSubAgent}/> 
								: (activeIndex ===6) ? <Settings  data={summaryData} formData={settings} setFormData={setSettings} flowJson={flowJson}/> 
								: (activeIndex ===7) ? <Configure  /> : null }
						</div>
                    </div>
                </div>
                </div>

			</>
	)
}
